// extracted by mini-css-extract-plugin
module.exports = {"cherryInfoWrapper":"ClientCherryInfo_cherryInfoWrapper__gv_cp","title":"ClientCherryInfo_title__1fzS1","itemText":"ClientCherryInfo_itemText__3q6cq"};